// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./+not-found.tsx": { enumerable: true, get() { return require("/Users/jorgeperezmartinez/Documents/GitHub/login/src/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/Users/jorgeperezmartinez/Documents/GitHub/login/src/app/_layout.tsx"); } },
  "./forgot-password.tsx": { enumerable: true, get() { return require("/Users/jorgeperezmartinez/Documents/GitHub/login/src/app/forgot-password.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/Users/jorgeperezmartinez/Documents/GitHub/login/src/app/index.tsx"); } },
  "./maintenance.tsx": { enumerable: true, get() { return require("/Users/jorgeperezmartinez/Documents/GitHub/login/src/app/maintenance.tsx"); } },
  "./reset-password.tsx": { enumerable: true, get() { return require("/Users/jorgeperezmartinez/Documents/GitHub/login/src/app/reset-password.tsx"); } },
  "./sso-login.tsx": { enumerable: true, get() { return require("/Users/jorgeperezmartinez/Documents/GitHub/login/src/app/sso-login.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;